export interface ShortTestimonial {
  initials: string
  name: string
  place: string
  quote: string
}

export const shortTestimonials: ShortTestimonial[] = [
  {
    initials: 'MC',
    name: 'María C.',
    place: 'Buenos Aires',
    quote: 'Al día 12 me puse un jean que no me entraba desde hacía dos años.',
  },
  {
    initials: 'LP',
    name: 'Laura P.',
    place: 'Córdoba',
    quote: 'El radar me mostró que la cebolla y el edulcorante eran el problema.',
  },
  {
    initials: 'SR',
    name: 'Sergio R.',
    place: 'Rosario',
    quote: 'Cinco años con “colon irritable”. Recién acá entendí el orden de las fases.',
  },
]

export interface LongTestimonial {
  name: string
  place: string
  quote: string
}

export const longTestimonials: LongTestimonial[] = [
  {
    name: 'María C.',
    place: 'Buenos Aires',
    quote:
      '“Vivía hinchada desde el desayuno. A la segunda semana del protocolo la panza dejó de crecer después de comer y volví a dormir sin molestias.”',
  },
  {
    name: 'Laura P.',
    place: 'Córdoba',
    quote:
      '“Había probado tres dietas por mi cuenta y siempre recaía. Acá entendí que me faltaba la fase de motilidad, no otra dieta más.”',
  },
  {
    name: 'Sergio R.',
    place: 'Rosario',
    quote:
      '“Llegué a la gastroenteróloga con el registro completo de un mes. Me dijo que era la primera vez que veía datos tan ordenados.”',
  },
  {
    name: 'Claudia M.',
    place: 'Mendoza',
    quote:
      '“Soy nutricionista y empecé con escepticismo. La estructura de las cinco fases es tan clara que hoy la uso como material de consulta.”',
  },
]

export const purchases: Array<[string, string]> = [
  ['María C.', 'Buenos Aires'],
  ['Laura P.', 'Córdoba'],
  ['Sergio R.', 'Rosario'],
  ['Claudia M.', 'Mendoza'],
]
